import { render, staticRenderFns } from "./BuildInstance.vue?vue&type=template&id=480f79b6"
import script from "./BuildInstance.vue?vue&type=script&lang=js"
export * from "./BuildInstance.vue?vue&type=script&lang=js"
import style0 from "./BuildInstance.vue?vue&type=style&index=0&id=480f79b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports